import { render, staticRenderFns } from "./SortItem.vue?vue&type=template&id=25fa652f&scoped=true&"
import script from "./SortItem.vue?vue&type=script&lang=js&"
export * from "./SortItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa652f",
  null
  
)

export default component.exports